import styled from "styled-components";

const VodToolTipWrapper = styled.div(
  ({ theme, position, isSafari }) => `
  width: 324px;
  height: fit-content;
  position: absolute;
  top: ${position === "progressbar" ? (isSafari ? "calc(100vh - 429px)" : "calc(100vh - 401px)") : ""};
  left: ${position === "progressbar" ? "40px" : ""};
  z-index: 999;
  padding: 20px;
  background-color: ${theme.colours.white};
  opacity: 1;
  color: ${theme.colours.black};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  `
);

const VodToolTipHeading = styled.div(
  ({ theme }) => `
  width: 275px;
  font-size: ${theme.typography.fontSize};
  font-weight: ${theme.typography.fontWeightSemiBold};
  line-height: 28.8px;
  margin-bottom: 8px;
  `
);

const VodToolTipMessage = styled.div(
  ({ theme, $isVodToolTipActive }) => `
  font-size: ${theme.typography.mediumFontSize};
  font-weight: ${theme.typography.fontWeightRegular};
  line-height: 27px;
  text-align: left;
  margin-bottom: 8px;
  max-width: ${$isVodToolTipActive ? "325px" : null};
  `
);
const VodToolTipArrow = styled.div`
  width: 0;
  height: 0;
  position: absolute;

  ${({ position, theme }) => {
    if (position === "progressbar") {
      return `
       border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-top: 12px solid ${theme.colours.white};
        left: 48px;
        bottom:-12px;
      `;
    }
  }}
`;

const VodToolTipHeaderWrapper = styled.div(
  () => `
  display: flex;
  justify-content: space-between;
  `
);

const VodToolTipCloseButton = styled.img(
  () => `
  width: 24px;
  height: 31px !important;
  cursor: pointer;
  position: relative;
  `
);

export {
  VodToolTipWrapper,
  VodToolTipHeading,
  VodToolTipMessage,
  VodToolTipArrow,
  VodToolTipHeaderWrapper,
  VodToolTipCloseButton,
};
